import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Proptypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import {
  NotificationService,
  NOTIFICATION_DURATIONS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
} from 'ui-components/services/notification-service';
import { useModal } from '../../../../../hooks/use-modal';
import ShipFromModal from '../../../../../ship-from/modals/';
import { trackShipFromConfigStart } from '../../../../../ship-from/tracking-events';

import messages from '../messages';
import useFetchShipFroms from '../../../ship-from-locations/use-fetch-ship-froms';

const AddShipFromButton = ({ children }) => {
  const { open, close, isOpen } = useModal();
  const { fetchShipFroms } = useFetchShipFroms();
  const onSuccess = useCallback(async () => {
    try {
      close();
      await fetchShipFroms();
      NotificationService.showNotification({
        notificationType: NOTIFICATION_TYPE_SUCCESS,
        title: <FormattedMessage {...messages.addShipFromSuccessMessageTitle} />,
        content: '',
        duration: NOTIFICATION_DURATIONS.SHORT,
      });
    } catch {
      NotificationService.showNotification({
        notificationType: NOTIFICATION_TYPE_ERROR,
        title: <FormattedMessage {...messages.addShipFromErrorMessageTitle} />,
        content: '',
        duration: NOTIFICATION_DURATIONS.SHORT,
      });
    }
  }, [fetchShipFroms, close]);

  const onClick = useCallback(() => {
    open();
    trackShipFromConfigStart('Settings - Delivery Options');
  }, [open]);

  return (
    <>
      <Button onClick={onClick} theme='link'>
        {children}
      </Button>
      {isOpen && <ShipFromModal onClose={close} onSuccess={onSuccess} />}
    </>
  );
};

AddShipFromButton.propTypes = {
  children: Proptypes.string.isRequired,
};

export default AddShipFromButton;
